import * as React from "react";
import { SvgIcon, SvgIconProps } from "../widget";

export default (props: SvgIconProps) => {
    return <SvgIcon {...props}>
        <path d="M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z" />
        <path fill="none" d="M0 0h24v24H0V0z" />
    </SvgIcon>
}